// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app-content[data-v-4bad4178]{display:flex;flex-grow:1;flex-direction:column;align-content:space-between}.app-navigation__photos[data-v-4bad4178] .app-navigation-entry-icon.icon-photos{background-size:20px}\n", ""]);
// Exports
module.exports = exports;
